export default "__VITE_ASSET__eGghiOrh__"